/**
 * Zzzing Guest API
 * Zzzing Guest API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AirportTransferBookingSummaryField = 'NUMBER_OF_PASSENGERS' | 'FLIGHT_NUMBER' | 'DRIVER_NOTES' | 'VEHICLE_DRIVER_NAME' | 'VEHICLE_MOBILE_NUMBER' | 'VEHICLE_REGISTRATION_NUMBER' | 'VEHICLE_TYPE' | 'PICKUP_ADDRESS' | 'PICKUP_LATITUDE' | 'PICKUP_LONGITUDE' | 'DROPOFF_ADDRESS' | 'DROPOFF_LATITUDE' | 'DROPOFF_LONGITUDE';

export const AirportTransferBookingSummaryField = {
    NumberOfPassengers: 'NUMBER_OF_PASSENGERS' as AirportTransferBookingSummaryField,
    FlightNumber: 'FLIGHT_NUMBER' as AirportTransferBookingSummaryField,
    DriverNotes: 'DRIVER_NOTES' as AirportTransferBookingSummaryField,
    VehicleDriverName: 'VEHICLE_DRIVER_NAME' as AirportTransferBookingSummaryField,
    VehicleMobileNumber: 'VEHICLE_MOBILE_NUMBER' as AirportTransferBookingSummaryField,
    VehicleRegistrationNumber: 'VEHICLE_REGISTRATION_NUMBER' as AirportTransferBookingSummaryField,
    VehicleType: 'VEHICLE_TYPE' as AirportTransferBookingSummaryField,
    PickupAddress: 'PICKUP_ADDRESS' as AirportTransferBookingSummaryField,
    PickupLatitude: 'PICKUP_LATITUDE' as AirportTransferBookingSummaryField,
    PickupLongitude: 'PICKUP_LONGITUDE' as AirportTransferBookingSummaryField,
    DropoffAddress: 'DROPOFF_ADDRESS' as AirportTransferBookingSummaryField,
    DropoffLatitude: 'DROPOFF_LATITUDE' as AirportTransferBookingSummaryField,
    DropoffLongitude: 'DROPOFF_LONGITUDE' as AirportTransferBookingSummaryField
};

